import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useNavigate } from "react-router-dom";

//hooks
import { useCategories } from "../../../hooks/hooks";

//styles
import { bgHeaders, dragActive } from "../../../styles/theme";

//images
import qrCode from './Ena_QR.png';

const CategoryWrapper = styled.div`
  width: 33.33%;
  // margin-bottom: calc(4 * var(--atom));
  padding: calc(2.5 * var(--atom));
  display: flex;
  // min-height: 350px;
  min-height: 45.6vh;
  color: #234182;

  &.qr {
    margin-left: auto;

    img {
      max-width: 120px ;
      max-height: 120px;
    }
  }

  @media (max-width: 991px) {
    width: 50%;
  }

  @media (max-width: 768px) {
    width: 100%;
  }

  .inner-wrapper {
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    padding: calc(4 * var(--atom));
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    cursor: pointer;
    background: ${bgHeaders};
    border-radius: calc(1.6 * var(--atom));
    // &:hover {
    //   background: #fafafa;
    // }
    > span {
      max-width: 100%;
      width: calc(28 * var(--atom));
      height: calc(28 * var(--atom));
      margin-bottom: calc(2 * var(--atom));
      display: flex !important;
      align-items: center;
      justify-content: center;

      > img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    > svg {
      max-width: calc(22.4 * var(--atom));
      max-height: calc(22.4 * var(--atom));
      margin-bottom: calc(2 * var(--atom));
    }
  }

  .title {
    font-size: calc(4.8 * var(--atom));
    line-height: calc(6.4 * var(--atom));
    margin-bottom: calc(2 * var(--atom));
    text-align: center;
  }

  .desc {
    font-size: calc(3.6 * var(--atom));
    line-height: calc(4.8 * var(--atom));
    text-align: center;
  }
  &:active {
    .inner-wrapper {
      // background: ${dragActive}
    }
  }
`;

interface Props {}

const PageHome: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { categories } = useCategories();
  const navigate = useNavigate();

  return (
    <div className="page-wrapper home">
      {categories.map((category: any) => (
        <CategoryWrapper key={category.id}>
          <div
            className="inner-wrapper"
            onClick={() => navigate(`/categories/${category.id}`)}
          >
            <LazyLoadImage
              alt={category?.["name:bg"]}
              src={category?.image?.path}
              effect="opacity"
            />
            <div className="title">{category?.name}</div>
            <div className="desc">{category?.description}</div>
          </div>
        </CategoryWrapper>
      ))}
      <CategoryWrapper className="qr">
        <div className="inner-wrapper no-shadow cursor-default">
          <img src={qrCode} className="mb-2" alt="Ena" />
          <div className="title">{t("pages.home.ena")}</div>
        </div>
      </CategoryWrapper>
    </div>
  );
};

export default PageHome;
